module.exports = __webpack_public_path__ + "img/logo.fbc54731.png";